export default "__VITE_ASSET__a4eaa2cc__"